import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CardHeaderTop from "../shared/CardHeaderTop";
import { upcomingScheduleList } from "../../utils/fackData/upcomingScheduleList";
import ImageGroup from "../shared/ImageGroup";
import useCardTitleActions from "../../hooks/useCardTitleActions";
import CardLoader from "../shared/CardLoader";
import { fetchData } from "../../utils/options";
import Swal from "sweetalert2";

const Schedule = ({ followup, permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const [loading, setLoading] = useState(true);

  const {
    refreshKey,
    isRemoved,
    isExpanded,
    handleRefresh,
    handleExpand,
    handleDelete,
  } = useCardTitleActions();
  const colorList = [
    "primary",
    "success",
    "info",
    "danger",
    "warning",
    "purple",
    "teal",
  ];
  if (permission?.pf_view !== 1) {
    return null;
  }
  if (isRemoved) {
    return null;
  }
  return (
    <div className="col-xxl-4">
      <div
        className={`card stretch stretch-full ${
          isExpanded ? "card-expand" : ""
        } ${refreshKey ? "card-loading" : ""}`}
      >
        {/* Latest Leads Heading */}
        <div className="card-header-d px-4 d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-bold">Follow-up Inquiry</h5>
          <CardHeaderTop
            refresh={handleRefresh}
            remove={handleDelete}
            expanded={handleExpand}
          />
        </div>

        <div className="card-body">
          {followup && followup.length > 0 ? (
            followup.map((val, index) => {
              const color = colorList[index % colorList.length];

              return (
                <div
                  key={index}
                  className="p-3 border border-dashed rounded-3 schedule-card"
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <div
                        className={`wd-50 ht-50 lh-1 d-flex align-items-center justify-content-center flex-column rounded-2 bg-soft-${color} text-${color} schedule-date`}
                      >
                        {val.follow_up_date && (
                          <>
                            <span className="loan_type_name2 fw-bold mb-1 d-block ps-3">
                              {new Date(val.follow_up_date).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                }
                              )}
                            </span>
                          </>
                        )}
                        {/* {date only} */}
                      </div>
                      <div className="text-dark">
                        <Link
                          to="#"
                          className="fw-bold mb-1 text-truncate-1-line"
                        >
                          {val.customer_name}
                        </Link>
                        <span className="fs-12 fw-normal text-muted text-truncate-1-line">
                          {val.follow_up_date && (
                            <>
                              <span className="loan_type_name2 fw-bold mb-1 d-block ">
                                {new Date(
                                  val.follow_up_date
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </span>
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="fw-semibold lh-0 ms-3 justify-content-start d-none d-sm-flex fs-13">
                      {val.loan_amount}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-muted p-3 text-center">
              No UpComing Data found
            </div>
          )}
        </div>
        <Link
          to="#"
          className="card-footer fs-11 fw-bold text-uppercase text-center py-4"
        >
       
        </Link>
        <CardLoader refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default Schedule;
